import { Pagination } from "api/models/response/pagination";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";

import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { GetMaterials } from "api/models/request/material/material";
import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import {
  IMaterialProperties,
  Material,
} from "mobx-stores/_models/material-inventory/material";
import { withSetPropAction } from "../_extension/with-set-props";
import { PaginationStore } from "./common/pagination-store";

export const MaterialQueryParams = types
  .model({
    type: "",
    name: "",
    code: "",
    barcode: "",
    isExactMatch: true,
  })
  .actions(withSetPropAction);
export const MaterialStore = types
  .model({
    materials: types.optional(types.array(Material), []),
    materialFilterOptions: types.optional(types.array(Material), []),
    materialFilterOptionsLoading: false,
    materialDetail: types.maybeNull(Material),
    pagination: types.optional(PaginationStore, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    queryParams: types.optional(MaterialQueryParams, {}),
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    loadMaterialFilterOptions: flow(function* loadMaterialFilterOptions() {
      if (self.materialFilterOptionsLoading) return;
      try {
        self.setProp("materialFilterOptionsLoading", true);
        const res = (yield materialBusiness.getLists({
          name: undefined,
          maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
          skipCount: 0,
          sorting: "",
        })) as Pagination<IMaterialProperties>;
        self.setProp("materialFilterOptions", res.items ?? []);
      } catch (ex) {
        console.error(ex);
      } finally {
        self.setProp("materialFilterOptionsLoading", false);
      }
    }),
    getMaterials: flow(function* getMaterials(request?: GetMaterials) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            name: self.queryParams.name,
            type: self.queryParams.type,
            code: self.queryParams.code,
            barcode: self.queryParams.barcode,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield materialBusiness.getLists(
          request,
        )) as Pagination<IMaterialProperties>;
        self.setProp("materials", res.items);
        self.pagination.setProp("totalItems", res.totalCount);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
